import intl from 'react-intl-universal';
import startsWith from 'lodash/startsWith';

import enUS from '../locales/en-US.json';
import uaUK from '../locales/ua-UK.json';
import ruRU from '../locales/ru-RU.json';
import { localeFromPrefix } from './layoutHelpers';

export const LOCALES = { 'en-US': enUS, 'ua-UK': uaUK, 'ru-RU': ruRU };

/**
 * The language prefix a path carries, empty for the primary language. Matches
 * the bare prefix and anything under it, so `/uk` and `/uk/blog` both resolve.
 */
const prefixFromPathname = (pathname: string): string => {
  if (pathname === '/uk' || startsWith(pathname, '/uk/')) {
    return '/uk';
  }
  if (pathname === '/ru' || startsWith(pathname, '/ru/')) {
    return '/ru';
  }
  return '';
};

/**
 * Initialise the react-intl-universal SINGLETON for a page path, BEFORE the
 * page renders.
 *
 * `wrapPageElement`, in both gatsby-browser and gatsby-ssr, calls it for every
 * page. It has to happen there because page templates call `intl.get()` inline
 * in their JSX, and those children evaluate during the PAGE's render — before
 * `<Layout>`, their parent-to-be, runs an init of its own.
 */
const initIntlForPath = (pathname: string): void => {
  void intl.init({
    currentLocale: localeFromPrefix(prefixFromPathname(pathname)),
    locales: LOCALES,
  });
};

export default initIntlForPath;
